import { RequerentePf } from './RequerentePf';
var RequerentePj = /** @class */ (function () {
    function RequerentePj() {
        this.socios = [];
        this.representante = new RequerentePf();
        this.telefoneComercial = '';
        this.razaoSocial = '';
        this.municipio = null;
        this.complemento = '';
        this.endereco = '';
        this.socios = [];
        this.celular = '';
        this.numero = '';
        this.bairro = '';
        this.email = '';
        this.estado = null;
        this.cep = '';
        this.cnpj = '';
    }
    return RequerentePj;
}());
export { RequerentePj };
var RequerentePjError = /** @class */ (function () {
    function RequerentePjError() {
    }
    return RequerentePjError;
}());
export { RequerentePjError };
